<script>
export default {
	name: 'ProductPrice',
	props: {
		amount: Number,
		currency: String,
		customClass: {
			type: String,
			default: 'font-3 font-weight-bold darkblue--text',
		},
	},
}
</script>

<template>
	<PriceText :amount="amount" :class="customClass" :currency="currency" />
</template>
